<template>
  <!-- 盒子 -->
  <div class="box-div" :class="`entrantsType${entrantsType}`">
    <img v-if="imgList.img && ifImg &&isimg" class="tui-img" :src="imgList.img" alt="" />

    <div class="zychoice">
      <!-- 选择xueyuan -->
      <div class="zychoiceTop">
        <div class="zychoiceTopLeft">全部学院：</div>
        <div class="zychoiceTopRight">
          <div class="right-item" :class="[!search.school ? 'on' : '']" @click="schoolClick()">
            全部
          </div>
          <div v-for="(item, ina) in schoollist" :key="ina" class="right-item"
            :class="search.school == item.pKind ? 'on' : ''" @click="schoolClick(item)">
            {{ item.pName }}
          </div>
        </div>
      </div>
      <!-- 选择项目 -->
      <div class="zychoiceTop">
        <div class="zychoiceTopLeft">全部项目：</div>
        <div class="zychoiceTopRight">
          <div class="right-item" :class="[!search.kind ? 'on' : '']" @click="kindClick()">
            全部
          </div>

          <div v-for="(item, ina) in kindList" :key="ina" class="right-item"
            :class="search.kind == item.pKind ? 'on' : ''" @click="kindClick(item)">
            {{ item.pName }}
          </div>
        </div>
      </div>

    </div>
  </div>
</template>
<script>
import Vue from "vue";


import { HomeClient } from "@/api/home";
const homeClient = new HomeClient();
import { getDomain } from "@/api/cookies";

export default {
  props: {
    isimg: {
      default: true,
      type: Boolean,
    },
    entrantsType: {
      default: 2,
      type: Number,
    },
    showSchool: {
      default: true,
      type: Boolean,
    },
    kind: {
      type: Number,
    },
    zyId: {
      type: Number,
    },
    schoole: {
      type: Number,
    },
    isJinpin: {
      type: Boolean,
      default: true,
    },
    showZy: {
      type: Boolean,
      default: true,
    },
    showKc: {
      type: Boolean,
      default: false,
    },
    type: {
      default: 1,
      type: Number,
    },
    ifImg: {
      type: Boolean,
      default: false,
    },
    showLevel: {
      type: Boolean,
      default: true,
    },
    testPaperType: {
      type: String,
    },
  },
  data() {
    return {
      imgList: {},
      search: {
        school: null,
        schoolName: null,
        type: null,
        name: null,
        examType: 1,
        kind: null,
        stage: "全部",
        zyId: null,
        kcId: null,
        kindName: null,
        stageName: null,
        zyName: null,
        kcName: null,
        productLine: 4, // 精品/普通班型
        types: "", // 课程类型 1直播 2录播 3音频 4 图文 5面授
        kcType: null, // 精品/普通课程
        areaId: null,
      },
      schoollist: [],
      kindList: [],
      stageList: [],
      Kindzylist: [], // 当前项目下的专业
      zylist: [],
      kcList: [],
      courseTypes: [
      ],

      kindZyName: "全部专业",
      zStage: "全部层次",


      provinceList: [], // 省份列表
      provinceIndex: null,
    };
  },

  async created() {
    this.domain = getDomain();

    homeClient
      .getSurfacePcList({ type: 4, entrantsType: this.domain.entrantsType })
      .then((res) => {
        if (res.code == 0) {
          if (res.data.length > 0) {
            this.imgList = res.data[0];
          } else {
            this.imgList = {};
          }
        }
      });
    if (this.showSchool) {
      await homeClient.getTenantKindNoZyList().then((res) => {
        if (res.code == 0) {
          this.schoollist = res.data;
          this.schoollist.forEach(item => {
            this.kindList.push(...item.kindList)
          });
        }
      });
    }



    if (this.schoole) {
      for (const item of this.schoollist) {
        if (item.pKind == this.schoole) {
          this.schoolClick(item);
          break;
        }
      }
    }
    if (this.kind) {
      for (const item of this.kindList) {
        if (item.pKind == this.kind) {
          this.kindClick(item);
          break;
        }
      }
    }


  },
  methods: {
    /* 学院  */
    async schoolClick(item) {
      if (item) {
        this.search.school = item.pKind;
        this.search.schoolName = item.pName;
        this.kindList = item.kindList;
        this.search.kind = null;
        this.search.kindName = null;
        this.search.zyId = "";
        this.search.zyName = "";
        this.search.kcId = "";
        this.search.kcName = "";
        this.search.areaId = "";
        this.kindZyName = "全部专业";
        this.zStage = "全部层次";
      } else {
        this.search.school = "";
        this.search.schoolName = "";

        this.search.kind = "";
        this.search.kindName = "";
        this.search.zyId = "";
        this.search.zyName = "";
        this.search.kcId = "";
        this.search.kcName = "";
        this.search.areaId = "";
        this.zStage = "全部层次";
        this.kindZyName = "全部专业";

        this.kindList = []
        this.schoollist.forEach(item => {
          this.kindList.push(...item.kindList)
        });
      }
      this.getLIst();
    },

    /* 项目选择 */
    async kindClick(item) {
      if (item) {
        this.search.kind = item.pKind;
        this.search.kindName = item.pName;

        this.stageList = item.pStage ? JSON.parse(item.pStage) : [];
        this.search.zyId = "";
        this.search.zyName = "";
        this.search.stage = "全部";
        this.search.stageName = "";
        this.search.kcId = "";
        this.search.kcName = "";
        this.search.areaId = "";
        this.provinceList = [];


        this.zylist = item.zyList;
        this.Kindzylist = item.zyList;
      } else {
        this.search.kind = "";
        this.zylist = [];
        this.Kindzylist = [];
        this.stageList = [];
        this.provinceList = [];
        this.search.kindName = "";
        this.search.zyId = "";
        this.search.zyName = "";
        this.search.stage = "全部";
        this.search.stageName = "";
        this.search.kcId = "";
        this.search.kcName = "";
        this.search.areaId = "";
        this.zStage = "全部层次";
        this.kindZyName = "全部专业";
      }

      this.getLIst();
    },







    /* 清空搜索 */
    changeList() {
      this.search.school = null;
      this.search.schoolName = null;
      this.search.type = null;
      this.search.kind = null;
      this.search.stage = "全部";
      this.search.zyId = null;
      this.search.kcId = null;
      this.search.kindName = null;
      this.search.stageName = null;
      this.search.zyName = null;
      this.search.kcName = null;
      this.search.productLine = 4; // 精品/普通班型
      this.search.kcType = null; // 精品/普通课程
      this.getTabList();
    },
    getLIst(i) {


      this.$nextTick(() => {
        this.$emit("isOk", this.search);
      });
    },
  },
};
</script>
<style lang="less" scoped>
/* 高校合伙人 */
.entrantsType3 {
  .zychoice {
    width: 1200px !important;
    background: #ffffff;
    border-radius: 8px 8px 8px 8px;
    opacity: 1;
    margin: 40px auto 24px;
    padding: 20px 32px 40px;

    .on {
      background: #f1f4ff !important;
      color: #4a6af0 !important;
    }
  }
}

.box-div {
  width: 100%;
  margin: 0px auto 0px;
}

.tui-img {
  width: 100%;
  height: 240px;
}

.zychoice {
  width: 100%;
  height: auto;
  box-shadow: 0px 0px 6px 0px rgba(216, 216, 216, 0.7);
  background: #ffffff;
  overflow: hidden;
  padding: 0px calc(50% - 610px) 32px;

  .zychoicePzion {
    width: 100%;
    background: #ffffff;
    height: 60px;
    border-bottom: 1px solid #eeeeee;
    display: flex;
    justify-content: flex-start;
    align-items: center;

    .el-breadcrumb {
      font-size: 15px;
      cursor: pointer;
    }
  }

  .zychoiceTop {
    width: 100%;
    background: #ffffff;
    padding-top: 20px;
    // height: 70px;
    height: auto;
    // border-bottom: 1px solid #eeeeee;
    box-sizing: border-box;
    display: flex;
    align-items: flex-start;
    font-size: 14px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: #999999;
    line-height: 30px;

    &:nth-child(1) {
      .right-item {
       // font-size: 16px !important;
      }
    }

    .zychoiceTopLeft {
      flex-shrink: 0;
    }

    .zychoiceTopRight {
      display: flex;
      align-items: flex-start;
      flex-wrap: wrap;

      .right-item {
        height: 30px;
        font-size: 14px;
        font-family: Microsoft YaHei-Regular, Microsoft YaHei;
        font-weight: 400;
        color: #666666;
        line-height: 30px;
        padding: 0px 16px;
        cursor: pointer;
      }

      .on {
        background: #f5f6f6;
        border-radius: 4px 4px 4px 4px;
        color: #ff5d51;
      }
    }
  }

  .zychoiceCen {
    width: 90%;
    height: 64px;
    margin: auto;
    display: flex;
    justify-content: flex-start;
    align-items: center;

    .spana {
      width: auto;
      height: auto;
      font-size: 15px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #27323f;
      margin-right: 53px;
      cursor: pointer;
    }

    .spanb {
      width: auto;
      height: auto;
      font-size: 15px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #27323f;
      margin-right: 40px;
      cursor: pointer;
    }

    .spanbs {
      width: auto;
      height: auto;
      font-size: 15px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #ff4027;
      margin-right: 40px;
      cursor: pointer;
    }

    .spanc {
      width: auto;
      height: auto;
      font-size: 15px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #27323f;
      margin-right: 30px;
      cursor: pointer;
    }

    .spancs {
      width: auto;
      height: auto;
      font-size: 15px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #ff4027;
      margin-right: 30px;
      cursor: pointer;
    }
  }
}

.tabBox {
  width: 1220px;
  margin: auto;
  margin-top: 40px;

  .list {
    display: flex;

    .item {
      cursor: pointer;
      font-size: 14px;
      font-family: Microsoft YaHei-Regular, Microsoft YaHei;
      font-weight: 400;
      color: #333333;
      line-height: 14px;

      .el-divider {
        margin: 0px 24px;
      }
    }

    .on {
      color: #ff5e51 !important;
    }
  }
}
</style>
